import React, { useState } from 'react';
import { get } from 'lodash';
import axios from 'axios';
import Waypoint from 'react-waypoint';
import Loading from '../Loading';

const GenesisList = ({
  walletId
}) => {
  const [isLoading, setLoading] = useState(true)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [genesises, setGenesises] = useState([])

  const fetchData = () => {
    if (shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/wallets/${walletId}/genesises`)
      .then((res) => {
        if (res.status == 200 && get(res, 'data.genesises')) {
          setGenesises(res.data.genesises)
          setShouldFetch(false)
          setLoading(false)
        }
      })
    }
  }

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3'>Genesises</h3>
      </div>

      <Waypoint onEnter={fetchData}>
        <div className='Table Table--genesises'>
          <div className='Table__row'>
            <div className='Table__col Table__col--th'>Image</div>
            <div className='Table__col Table__col--th'>Token id</div>
            <div className='Table__col Table__col--th'>Name</div>
            <div className='Table__col Table__col--th'>Attributes</div>
          </div>

          <Loading
            isLoading={isLoading && genesises.length == 0}
          >
            {genesises.map((genesis) => (
              <div key={genesis.token_id} className='Table__row'>
                <div className='Table__col'>
                  <img
                    src={genesis.image}
                    width={60}
                    height={60}
                  />
                </div>
                <div className='Table__col'>{genesis.token_id}</div>
                <div className='Table__col'>{genesis.name}</div>
                <div className='Table__col'>
                  {genesis.attributes.map((attribute, index) => (
                    <span key={index}>{attribute.trait_type}: {attribute.value}<br /></span>
                  ))}
                </div>
              </div>
            ))}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  )
}

export default GenesisList
